<template>
    <div :class="[compObject?.objectable?.wrapper_class, 'w-full mt-4 pr-4 mb-8']">
        <vue-vimeo-player :ref="`player-${video.video_id}`" :options="{responsive: video?.responsive===1 ? true : false}" :video-id="video?.video_id" :class="[video?.video_class, {'flex flex-wrap justify-center items-center': !video?.responsive}]" :player-width="parseInt(video?.width)" :player-height="parseInt(video?.height)" :key="video?.id" />
        <p v-if="compObject?.objectable?.title" :class="compObject?.objectable?.title_class">
            <span class="font-bold text-xs">{{ compObject?.objectable?.title }}</span>
        </p>
        <p v-if="compObject?.objectable?.description" :class="['text-sm', compObject?.objectable?.title_class]" v-html="compObject?.objectable?.description"></p>
    </div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player'

export default {
   name: "videoComponent",
   components: { vueVimeoPlayer },
   props: ['compObject'],
   computed: {
        video() {
            return this.compObject?.objectable;
        }
   },
   data() {
       return {

       }
   },
   mounted() {

   },
   methods: {

   }
}
</script>
